import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import SearchAPIBuilder from './SearchAPIBuilder';
import { generateSearchApiParameters } from '../../../utils/constants';

class SearchAPI extends Component {
  render() {
    const { pixel, website } = this.props;
    const tableHeader = ['Parameter', 'Type', 'Required', 'Description', 'Default'];
    const parameterInformation = generateSearchApiParameters(pixel);
    
    return (
      <div>
        <p>To retrieve jobs from the JobAdX API you must create a <b>GET</b> request to: </p>
        <pre>{`https://${website.search_domain}/v2/publisher/jobs`}</pre>
        <br />
        <h3>Request Parameters</h3>
        <div style={{ overflowX: 'auto' }}>
          <Table bordered>
            <thead>
              <tr>
                {tableHeader.map((header, i) => {
                  return (<th key={i}> {header} </th>);
                })}
              </tr>
            </thead>
            <tbody>
              {parameterInformation.map((parameter, i) => {
                return (<tr key={i}>
                  <td>
                    {parameter.parameter}
                  </td>
                  <td>
                    {parameter.type}
                  </td>
                  <td>
                    {parameter.required}
                  </td>
                  <td dangerouslySetInnerHTML={{ __html: parameter.description }} />
                  <td>
                    {parameter.default}
                  </td>
                </tr>);
              })}
            </tbody>
          </Table>
        </div>
        <h3>Search API URL Builder</h3>
        <div>
          <SearchAPIBuilder website={website} pixelId={pixel.data && pixel.data.uuid} />
        </div>
      </div>
    );
  }
}

export default SearchAPI;
